"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flowchart = exports.code = exports.brand = exports.icon = exports.button = exports.bg = exports.text = exports.border = void 0;
const primitives_1 = require("./primitives");
exports.border = {
    primary: {
        base: primitives_1.silver[400],
        dark: primitives_1.navy[400],
    },
    /** @deprecated This token has been removed. Please use `primary`. */
    secondary: {
        base: primitives_1.silver[400],
        dark: primitives_1.navy[300],
    },
    hover: {
        base: primitives_1.gray[300],
        dark: primitives_1.navy[300],
    },
    success: {
        base: primitives_1.green[400],
        dark: primitives_1.green[300],
    },
    error: {
        base: primitives_1.red[400],
        dark: primitives_1.red[250],
    },
    warning: {
        base: primitives_1.orange[400],
        dark: primitives_1.orange[300],
    },
    neutral: {
        base: primitives_1.navy[400],
        dark: primitives_1.navy[200],
    },
    info: {
        base: primitives_1.blue[400],
        dark: primitives_1.blue[200],
    },
    beta: {
        base: primitives_1.purple[400],
        dark: primitives_1.purple[200],
    },
    highlight: {
        base: primitives_1.yellow[400],
        dark: primitives_1.yellow[400],
    },
    focused: {
        base: primitives_1.blue[400],
        dark: primitives_1.blue[200],
    },
    disabled: {
        base: primitives_1.silver[400],
        dark: primitives_1.navy[300],
    },
    selected: {
        base: primitives_1.navy[400],
        dark: primitives_1.navy[200],
    },
    splitbutton: {
        base: primitives_1.navy[500],
        dark: primitives_1.navy[300],
    },
    deselected: {
        base: primitives_1.gray[500],
        dark: primitives_1.gray[400],
    },
    white: {
        base: primitives_1.silver[100],
        dark: primitives_1.silver[100],
    },
    black: {
        base: primitives_1.navy[400],
        dark: primitives_1.navy[400],
    },
    tab: {
        base: primitives_1.navy[400],
        dark: primitives_1.navy[200],
    },
};
const heading = {
    base: primitives_1.navy[500],
    dark: primitives_1.silver[200],
};
exports.text = {
    primary: {
        base: primitives_1.gray[600],
        dark: primitives_1.silver[500],
    },
    secondary: {
        base: primitives_1.gray[500],
        dark: primitives_1.gray[300],
    },
    placeholder: {
        base: primitives_1.gray[500],
        dark: primitives_1.gray[300],
    },
    heading,
    /**
     * @deprecated Use `heading` instead.
     */
    header: heading,
    link: {
        base: primitives_1.gray[600],
        dark: primitives_1.silver[500],
    },
    success: {
        base: primitives_1.green[500],
        dark: primitives_1.green[200],
    },
    error: {
        base: primitives_1.red[400],
        dark: primitives_1.red[200],
    },
    warning: {
        base: primitives_1.orange[500],
        dark: primitives_1.orange[200],
    },
    neutral: {
        base: primitives_1.gray[600],
        dark: primitives_1.gray[100],
    },
    info: {
        base: primitives_1.blue[500],
        dark: primitives_1.blue[100],
    },
    beta: {
        base: primitives_1.purple[500],
        dark: primitives_1.purple[100],
    },
    disabled: {
        base: primitives_1.gray[200],
        dark: primitives_1.navy[300],
    },
    inverted: {
        base: primitives_1.silver[100],
        dark: primitives_1.navy[500],
    },
    white: {
        base: primitives_1.silver[100],
        dark: primitives_1.silver[100],
    },
    black: {
        base: primitives_1.gray[600],
        dark: primitives_1.gray[600],
    },
};
const deselected = {
    base: primitives_1.gray[500],
    dark: primitives_1.gray[400],
};
exports.bg = {
    primary: {
        base: primitives_1.silver[100],
        dark: primitives_1.black[100],
    },
    secondary: {
        base: primitives_1.silver[300],
        dark: primitives_1.black[200],
    },
    success: {
        base: primitives_1.green[100],
        dark: primitives_1.green[600],
    },
    successSelected: {
        base: primitives_1.green[200],
        dark: primitives_1.green[400],
    },
    error: {
        base: primitives_1.red[100],
        dark: primitives_1.red[600],
    },
    errorSelected: {
        base: primitives_1.red[200],
        dark: primitives_1.red[500],
    },
    errorHover: {
        base: primitives_1.red[250],
        dark: primitives_1.red[200],
    },
    warning: {
        base: primitives_1.orange[100],
        dark: primitives_1.orange[700],
    },
    warningSelected: {
        base: primitives_1.orange[200],
        dark: primitives_1.orange[500],
    },
    warningHover: {
        base: primitives_1.orange[350],
        dark: primitives_1.orange[200],
    },
    neutral: {
        base: primitives_1.silver[400],
        dark: primitives_1.navy[450],
    },
    info: {
        base: primitives_1.blue[100],
        dark: primitives_1.blue[600],
    },
    infoHover: {
        base: primitives_1.blue[300],
        dark: primitives_1.blue[200],
    },
    notice: {
        base: primitives_1.blue[400],
        dark: primitives_1.blue[200],
    },
    beta: {
        base: primitives_1.purple[100],
        dark: primitives_1.purple[600],
    },
    betaHover: {
        base: primitives_1.purple[300],
        dark: primitives_1.purple[200],
    },
    highlight: {
        base: primitives_1.yellow[100],
        dark: primitives_1.yellow[600],
    },
    searchHighlight: {
        base: primitives_1.green[500],
        dark: primitives_1.green[200],
    },
    tableHeader: {
        base: primitives_1.silver[300],
        dark: primitives_1.navy[400],
    },
    tableHover: {
        base: primitives_1.silver[300],
        dark: primitives_1.black[300],
    },
    input: {
        base: primitives_1.silver[100],
        dark: primitives_1.navy[450],
    },
    white: {
        base: primitives_1.silver[100],
        dark: primitives_1.silver[100],
    },
    black: {
        base: primitives_1.black[100],
        dark: primitives_1.black[100],
    },
    overlay: {
        base: primitives_1.black[300],
        dark: primitives_1.black[300],
    },
    selected: {
        base: primitives_1.navy[300],
        dark: primitives_1.navy[400],
    },
    deselected,
    /**
     * @deprecated Use `deselected` instead.
     */
    unselected: deselected,
    disabled: {
        base: primitives_1.silver[400],
        dark: primitives_1.navy[400],
    },
    blueTagHover: {
        base: primitives_1.blue[200],
        dark: primitives_1.blue[500],
    },
    grayTagHover: {
        base: primitives_1.silver[500],
        dark: primitives_1.navy[500],
    },
};
exports.button = {
    primary: {
        base: primitives_1.navy[400],
        dark: primitives_1.navy[200],
    },
    primaryHover: {
        base: primitives_1.navy[500],
        dark: primitives_1.navy[300],
    },
    primarySelected: {
        base: primitives_1.navy[300],
        dark: primitives_1.navy[400],
    },
    destructive: {
        base: primitives_1.red[400],
        dark: primitives_1.red[400],
    },
    destructiveHover: {
        base: primitives_1.red[500],
        dark: primitives_1.red[500],
    },
    secondary: {
        base: primitives_1.silver[100],
        dark: primitives_1.black[100],
    },
    secondaryHover: {
        base: primitives_1.silver[300],
        dark: primitives_1.black[300],
    },
    secondarySelected: {
        base: primitives_1.silver[400],
        dark: primitives_1.navy[300],
    },
    /** @deprecated This token has been removed. Please use `bg.disabled`. */
    disabled: {
        base: primitives_1.silver[400],
        dark: primitives_1.navy[400],
    },
};
exports.icon = {
    primary: exports.text.primary,
    secondary: {
        base: primitives_1.gray[500],
        dark: primitives_1.gray[400],
    },
    success: {
        base: primitives_1.green[400],
        dark: primitives_1.green[200],
    },
    error: {
        base: primitives_1.red[400],
        dark: primitives_1.red[250],
    },
    warning: {
        base: primitives_1.orange[400],
        dark: primitives_1.orange[300],
    },
    change: {
        base: primitives_1.yellow[500],
        dark: primitives_1.yellow[300],
    },
    info: {
        base: primitives_1.blue[400],
        dark: primitives_1.blue[200],
    },
    beta: {
        base: primitives_1.purple[400],
        dark: primitives_1.purple[200],
    },
    disabled: {
        base: primitives_1.gray[200],
        dark: primitives_1.navy[300],
    },
    inverted: {
        base: primitives_1.silver[100],
        dark: primitives_1.navy[500],
    },
    white: {
        base: primitives_1.silver[100],
        dark: primitives_1.silver[100],
    },
};
const nebula = {
    base: primitives_1.navy[500],
    dark: primitives_1.navy[100],
};
const satellite = {
    base: primitives_1.gray[400],
    dark: primitives_1.gray[400],
};
const regolith = {
    base: primitives_1.beige[500],
    dark: primitives_1.beige[400],
};
const horizon = {
    base: primitives_1.orange[400],
    dark: primitives_1.orange[300],
};
exports.brand = {
    nebula,
    primary: nebula,
    satellite,
    secondary: satellite,
    regolith,
    tertiary: regolith,
    horizon,
    accent: horizon,
};
exports.code = {
    a: {
        base: primitives_1.gray[500],
        dark: primitives_1.gray[200],
    },
    b: {
        base: primitives_1.blue[400],
        dark: primitives_1.blue[200],
    },
    c: {
        base: primitives_1.purple[300],
        dark: primitives_1.purple[200],
    },
    d: {
        base: primitives_1.green[500],
        dark: primitives_1.green[300],
    },
    e: {
        base: primitives_1.yellow[500],
        dark: primitives_1.yellow[300],
    },
    f: {
        base: primitives_1.navy[300],
        dark: primitives_1.navy[100],
    },
    g: {
        base: primitives_1.orange[500],
        dark: primitives_1.orange[200],
    },
};
const d = {
    base: primitives_1.blue[300],
    dark: primitives_1.blue[200],
};
exports.flowchart = {
    text: exports.text.primary,
    a: exports.code.e,
    b: exports.code.d,
    c: {
        base: primitives_1.orange[400],
        dark: primitives_1.orange[300],
    },
    d,
    /** @deprecated This token has been removed. Please use `d`. */
    e: d,
};
//# sourceMappingURL=tokens.js.map